import { AppUI } from '@seedlang/state';

export default function gatekeepDiscordLink(discordLink) {
  if (!AppUI.userIsSignedIn || !AppUI.user?.isMember) {
    return '/pages/discord-join';
  }

  const alreadyConnected = AppUI.user?.elDiscordAssociationExists;
  const isAdmin = AppUI.user.isAdminForSite(AppUI.site.id);
  const discordMembershipTypeIds = (AppUI.site.discordMembershipTypes || '').split(',').filter(Boolean);
  const hasDiscordAccess = isAdmin || discordMembershipTypeIds.includes(AppUI.user.currentGroupMembershipType?.id);

  if (hasDiscordAccess && alreadyConnected) {
    return discordLink;
  }

  if (hasDiscordAccess && !alreadyConnected) {
    return '/settings/pages/discord-access';
  }

  return '/pages/discord-upgrade';
}
